import * as angular from "angular";
import { Filter } from "../../models/filter.model";
import { FilterDataProvider } from "../../data-provider/filter.dp";

let AdminOrganisationsComponent = {
    selector: "vcAdminOrganisations",
    templateUrl: "/angular/components/admin/admin-organisations.component.html",
    bindings: {},
    controller: class AdminOrganisationsController {
        public filter = new Filter({
            search: { values: "", checked: true },
            thisRegion: null,
        });

        constructor(FilterDataProvider: FilterDataProvider) {
            // "Accounts I'm On" is shared with the Accounts page (AV-17963).
            const shared =
                FilterDataProvider && FilterDataProvider.appliedFilter;
            this.filter.attached = !!(shared && shared.attached);
        }
    },
};

angular
    .module("admin")
    .component(
        AdminOrganisationsComponent.selector,
        AdminOrganisationsComponent
    );
